import trackAddToCartDy from './trackAddToCartDy';
import trackRemoveFromCartDy from './trackRemoveFromCartDy';

/**
*	Tracks updates to cart quantities then triggers Dynamic Yield Add to Cart event accordingly
*
*	@param {Array} newProductItems - The list of products in cart after quantity update
*	@param {Array} oldProductItems - The list of products in cart before quantity update
* */
function trackDyCartQuantityUpdates (newProductItems, oldProductItems) {

	if (window.DY) {

		try {

			// Get all items with updated qty
			const updatedQtyItems = newProductItems.filter((updatedItem) => {

				const oldItem = oldProductItems.find((pi) => pi.Id === updatedItem.Id);

				return oldItem
                    && oldItem.Quantity !== updatedItem.Quantity;

			}).map((updatedItem) => {

				const oldItem = oldProductItems.find((pi) => pi.Id === updatedItem.Id);
				const quantityDelta = Math.abs(oldItem.Quantity - updatedItem.Quantity);

				return {
					shortSku: updatedItem.ShortSku,
					quantity: quantityDelta,
					price: parseFloat((quantityDelta * updatedItem.PurchasePricePerUnit)
						.toFixed(2)),
					quantityDecreased: oldItem.Quantity > updatedItem.Quantity
				};

			});

			// We also want to track new items that have been added (not available in old product items array)
			// For example, when splitting recommended bulbs into a separate line item
			const newItemsAdded = newProductItems
				// eslint-disable-next-line max-len
				.filter((newPI) => !oldProductItems.some((oldPI) => oldPI.Id === newPI.Id && oldPI.ShortSku === newPI.ShortSku))
				.map((newPI) => ({
					shortSku: newPI.ShortSku,
					quantity: newPI.Quantity,
					price: newPI.PriceSubTotal,
					quantityDecreased: false
				}));
			const cartItemsToTrack = [ ...updatedQtyItems, ...newItemsAdded ];

			// there might be multiple items with update quantities
			// fire event for each
			if (cartItemsToTrack.length) {

				cartItemsToTrack.forEach((item) => {

					const {
						shortSku, price, quantity, quantityDecreased
					} = item;

					// decreasing quantity will trigger DY Remove From Cart event
					if (quantityDecreased) {

						trackRemoveFromCartDy(shortSku, price, quantity);

					} else {

						trackAddToCartDy(shortSku, price, quantity);

					}

				});

			}

		} catch (error) {

			console.error(error.message);

		}

	}

}

export default trackDyCartQuantityUpdates;
